import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getHomeSecondSecData } from '../../../Redux/action/MasterAction';
import SkeletonLoaderTutorFlow from '../../../Common/skeleton/HomeSecondSec/SkeletonTutorFlow';
import Aos from 'aos';
import "aos/dist/aos.css";
const host = process.env.REACT_APP_API_SERVER
const TutorFlow = () => {

    const dispatch = useDispatch();

    const {
        loadingHomeSecondSecDataApi,
        HomeSecondSecDataApiData,
        HomeSecondSecDataApiError,

    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        dispatch(getHomeSecondSecData())
       
    }, []);
    // if (loadingHomeSecondSecDataApi) {
    //     return <SkeletonLoaderTutorFlow />;
    //   }

    useEffect(function () {
        Aos.init({
             duration: 1000,
             disable: "mobile"
             });
      }, []);

    return (
        <>
       {loadingHomeSecondSecDataApi?
       <SkeletonLoaderTutorFlow/>
       :
        <section className="how-it-works"  data-aos="fade-up">
            <div className="container">
                <div
                    className="section-header text-center"
                   
                >
                    <div className="heading">
                        
                        <span className="ruby section-badge">
                            TUTORING FLOW
                        </span>
                       
                    </div>
                    <h4>{HomeSecondSecDataApiData?.home_section_two_title}</h4>
                    <p className="sub-title">
                        {HomeSecondSecDataApiData?.home_section_two_subtitle}
                    </p>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div
                            className="feature-box text-center"
                           
                        >
                            <div className="feature-header">
                                <div className="feature-icon">
                                    <span className="circle" />
                                    <i>
                                        <img
                                            src={`${host}${HomeSecondSecDataApiData?.home_section_two_image_one_image}`}
                                        />
                                    </i>
                                </div>
                                <div className="feature-cont">
                                    <div className="feature-text">{HomeSecondSecDataApiData?.home_section_two_image_one_title}</div>
                                </div>
                            </div>
                            <p className="mb-0">
                                {HomeSecondSecDataApiData?.home_section_two_image_one_subtitle}
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div
                            className="feature-box feature-box-two text-center"
                           
                        >
                            <div className="feature-header">
                                <div className="feature-icon">
                                    <span className="circle" />
                                    <i>
                                        <img
                                            src={`${host}${HomeSecondSecDataApiData?.home_section_two_image_two_image}`}
                                        />
                                    </i>
                                </div>
                                <div className="feature-cont">
                                    <div className="feature-text">{HomeSecondSecDataApiData?.home_section_two_image_two_title}</div>
                                </div>
                            </div>
                            <p className="mb-0">
                                {HomeSecondSecDataApiData?.home_section_two_image_two_subtitle}
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div
                            className="feature-box1 feature-box-three text-center"
                            
                        >
                            <div className="feature-header">
                                <div className="feature-icon">
                                    <span className="circle" />
                                    <i>
                                        <img
                                            src={`${host}${HomeSecondSecDataApiData?.home_section_two_image_three_image}`}
                                        />
                                    </i>
                                </div>
                                <div className="feature-cont">
                                    <div className="feature-text">{HomeSecondSecDataApiData?.home_section_two_image_three_title}</div>
                                </div>
                            </div>
                            <p className="mb-0">
                                {HomeSecondSecDataApiData?.home_section_two_image_three_subtitle}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>}
        </>
    )
}

export default TutorFlow